<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel()"
  >
    <v-card tile>
      <v-card-title class="primary white--text py-1">
        <h3 class="headline">{{ $t(`texts.${ textKeys.title || 'confirm' }`) }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="cancel()">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-4">
        {{ $t(`texts.${ textKeys.message || 'confirmMessage' }`) }}
      </v-card-text>
      <v-divider/>
      <v-card-actions class="justify-end">
        <v-btn depressed text @click="cancel()">
          {{ $t(`texts.${ textKeys.reject || 'no'}`) }}
        </v-btn>
        <v-btn depressed color="primary" @click="agree()">
          {{ $t(`texts.${ textKeys.confirm || 'yes'}`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmation-dialog',
  props: {
    options: {
      type: Object,
      default: () => ({
        color: 'primary',
        width: 320,
      }),
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      textKeys: {
        title: '',
        message: '',
        confirm: '',
        reject: '',
      },
    };
  },
  methods: {
    open(texts, options) {
      this.dialog = true;
      Object.assign(this.textKeys, texts);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
